import { render, staticRenderFns } from "./Y67TPrimaryStudentList.vue?vue&type=template&id=bd5ed498&scoped=true&"
import script from "./Y67TPrimaryStudentList.vue?vue&type=script&lang=js&"
export * from "./Y67TPrimaryStudentList.vue?vue&type=script&lang=js&"
import style0 from "./Y67TPrimaryStudentList.vue?vue&type=style&index=0&id=bd5ed498&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5ed498",
  null
  
)

export default component.exports